export default {
    price: 1000,
    light: {
        primary: '#29C229',
        secondary: '#424242',
        accent: '#92EF92',
    },
    dark: {
        primary: '#29C229',
        secondary: '#424242',
        accent: '#92EF92',
    }
}
